import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

function resolveLocale (value) {
  return String(value || '').toLowerCase().startsWith('zh') ? 'zh-CN' : 'en-US'
}

const savedLocale = localStorage.getItem('locale')
const browserLocale = navigator.language || navigator.userLanguage
const initialLocale = savedLocale ? resolveLocale(savedLocale) : resolveLocale(browserLocale)

if (!savedLocale) localStorage.setItem('locale', initialLocale)

const i18n = new VueI18n({
  locale: initialLocale,
  messages: {
    'zh-CN': zh,
    'en-US': en
  }
})

export default i18n
